/**
 * The हि toggle (D19 phase 21, the kit's top bar): the menu's workspace and group names in Hindi. Screen names stay
 * English until the old ERP's dictionary is ported (v6 §3.1, kind A). Kept in this browser; every copy hears a change.
 */
import { useEffect, useState } from 'react';

export type NavLang = 'en' | 'hi';
const KEY = 'rtcom.lang';
const EVENT = 'rtcom:lang';

const read = (): NavLang => { try { return localStorage.getItem(KEY) === 'hi' ? 'hi' : 'en'; } catch { return 'en'; } };

export function useNavLang(): [NavLang, (next: NavLang) => void] {
  const [lang, setLang] = useState<NavLang>(read);
  useEffect(() => {
    const on = () => setLang(read());
    window.addEventListener(EVENT, on);
    return () => window.removeEventListener(EVENT, on);
  }, []);
  return [lang, (next) => {
    try { localStorage.setItem(KEY, next); } catch { /* storage blocked: this tab only */ }
    setLang(next);
    window.dispatchEvent(new Event(EVENT));
  }];
}
